<script>
    import { findLookupId } from '../helpers';
    import lookups from '../stores/lookupStore';

    import TextInput from './TextInput.svelte';
    import TextDisplay from './TextDisplay.svelte';
    import DatePicker from './DatePicker.svelte';
    import DisplayRow from './DisplayRow.svelte';
    import FormRow from './FormRow.svelte';
    import FormColumn from './FormColumn.svelte';

    export let claimant;
    export let groupMemberInformation = null;
    export let disabled = null;

    if (!claimant.initialised) {
        claimant.initialised = true;
	    claimant.allowDoBUpdate = !claimant.dateOfBirth
    }
</script> 

<DisplayRow>
    <FormColumn cols="12">
		<TextDisplay
			label="Name of Estate"
			value="{claimant.firstName} {claimant.surname}" />
    </FormColumn>
</DisplayRow>

{#if !disabled}

    <FormRow>
        <FormColumn cols="3">
            {#if claimant.allowDoBUpdate}
                <DatePicker
                    required
                    disabled={disabled}
                    id="e_dateOfBirth"
                    label="Date of birth"
                    validator={true}
                    start={new Date(1924, 0, 1)}
                    end={new Date()}
                    placeholder="e.g. 01/05/1987"
                    bind:formattedSelected={claimant.dateOfBirth}
                    openOnClass="calendar-icon" />
            {:else}
                <TextDisplay
                    label="Date of birth"
                    value={claimant.dateOfBirth} />
            {/if}
        </FormColumn>
        <FormColumn cols="3">
            <DatePicker
                required
                disabled={disabled}
                id="e_dateOfDeath"
                label="Date of death"
                validator={true}
                start={new Date(1924, 0, 1)}
                end={new Date()}
                placeholder="e.g. 01/05/1987"
                bind:formattedSelected={claimant.dateOfDeath}
                openOnClass="calendar-icon" />
        </FormColumn>
        <FormColumn cols="6">
            <TextInput
                required
                {disabled}
                id="e_causeOfDeath"
                label="Cause of death"
                bind:value={groupMemberInformation.causeOfDeath} />
        </FormColumn>
    </FormRow>

    <FormRow>
        <FormColumn cols="12">
            <TextInput
                required
                {disabled}
                label="Your relationship to the Deceased"
                bind:value="{groupMemberInformation.relationshipWithGroupMember}"
                id="relationshipWithDeceased"
                maxlength="50" />
        </FormColumn>
    </FormRow>

{:else}

    <DisplayRow>
        <FormColumn cols="3">
            <TextDisplay
                label="Date of death"
                value={claimant.dateOfBirth} />
        </FormColumn>
        <FormColumn cols="3">
            <TextDisplay
                label="Date of death"
                value={claimant.dateOfDeath} />
        </FormColumn>
        <FormColumn cols="6">
            <TextDisplay
                label="Cause of death"
                value={groupMemberInformation.causeOfDeath} />
        </FormColumn>
    </DisplayRow>

    <DisplayRow>
        <FormColumn cols="12">
            <TextDisplay
                label="Your relationship to the Deceased"
                value="{groupMemberInformation.relationshipWithGroupMember}" />
        </FormColumn>
    </DisplayRow>

{/if}